import React from 'react'
import { Box, Typography } from '@mui/material'
import { Container, Row, Col, Image } from 'react-bootstrap'
import afford from '../Assets/Images/afford-travel.png'
import innovation from '../Assets/Images/innovation-lightbulb.png'
import timeCalender from '../Assets/Images/time-management.png'
import comfort from '../Assets/Images/comfort.png'
import booking from '../Assets/Images/online-booking.png'
import crew from '../Assets/Images/crew.png'


const FeatureCards = () => {
  return (
    <>
      <Box className="featureCardMain">
        <Container>
            <Row>
                <Col lg="12">
                  <Typography variant="h2">Discover Perks of <Typography variant="body1" style={{fontSize: '60px'}} component="span">Shankh Air</Typography></Typography>
                </Col>
            </Row>
            <Box className="benefitCards">
              <Row>
                  <Col lg="4">
                    <Box className="cardItems">
                      <Box className="cardImg">
                        <Image src={afford} className='img-fluid'></Image>
                      </Box>
                      <Box className="cardText">
                        <Typography variant="h6">Accessibility & Affordability</Typography>
                        <Typography variant="body1" component="p">From lower fares and simplified booking to easy payment options, Shankh Air removes barriers so even first-time flyers can travel comfortably.</Typography>
                      </Box>
                    </Box>
                  </Col>

                  <Col lg="4">
                    <Box className="cardItems">
                      <Box className="cardImg">
                        <Image src={innovation} className='img-fluid'></Image>
                      </Box>
                      <Box className="cardText">
                        <Typography variant="h6">Innovation</Typography>
                        <Typography variant="body1" component="p">Merging the best of modern aviation with the spirit of our traditions.Bringing cutting-edge technology to the skies. we honor our rich heritage in every flight.</Typography>
                      </Box>
                    </Box>
                  </Col>

                  <Col lg="4">
                    <Box className="cardItems">
                      <Box className="cardImg">
                        <Image src={timeCalender} className='img-fluid'></Image>
                      </Box>
                      <Box className="cardText">
                        <Typography variant="h6">Flexible Schedule</Typography>
                        <Typography variant="body1" component="p">Our technology consistently delivers the best pricing for airline – and the unique ability to buy individual seats all over the state orcountry.</Typography>
                      </Box>
                    </Box>
                  </Col>

                  <Col lg="4">
                    <Box className="cardItems">
                      <Box className="cardImg">
                        <Image src={comfort} className='img-fluid'></Image>
                      </Box>
                      <Box className="cardText">
                        <Typography variant="h6">Seamless Comfort</Typography>
                        <Typography variant="body1" component="p">From lower fares and simplified booking to easy payment options, Shankh Air removes barriers so even first-time flyers can travel comfortably.</Typography>
                      </Box>
                    </Box>
                  </Col>

                  <Col lg="4">
                    <Box className="cardItems">
                      <Box className="cardImg">
                        <Image src={crew} className='img-fluid'></Image>
                      </Box>
                      <Box className="cardText">
                        <Typography variant="h6">Experienced Crew</Typography>
                        <Typography variant="body1" component="p">Merging the best of modern aviation with the spirit of our traditions.Bringing cutting-edge technology to the skies. we honor our rich heritage in every flight.</Typography>
                      </Box>
                    </Box>
                  </Col>

                  <Col lg="4">
                    <Box className="cardItems">
                      <Box className="cardImg">
                        <Image src={booking} className='img-fluid'></Image>
                      </Box>
                      <Box className="cardText">
                        <Typography variant="h6">Smooth Booking</Typography>
                        <Typography variant="body1" component="p">Our technology consistently delivers the best pricing for airline – and the unique ability to buy individual seats all over the state orcountry.</Typography>
                      </Box>
                    </Box>
                  </Col>
              </Row>
            </Box>
        </Container>
      </Box>
    </>
  )
}

export default FeatureCards
